/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Get_Premium_DescriptionInputs */

const en_plan_get_premium_description = /** @type {(inputs: Plan_Get_Premium_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe to unlock unlimited listening. If you started a checkout that didn't finish, this picks it back up.`)
};

const es_plan_get_premium_description = /** @type {(inputs: Plan_Get_Premium_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscríbete para escuchar sin límites. Si empezaste un pago que no se completó, esto lo retoma.`)
};

/**
* | output |
* | --- |
* | "Subscribe to unlock unlimited listening. If you started a checkout that didn't finish, this picks it back up." |
*
* @param {Plan_Get_Premium_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_get_premium_description = /** @type {((inputs?: Plan_Get_Premium_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Get_Premium_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_get_premium_description(inputs)
	return en_plan_get_premium_description(inputs)
});